import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { MailListRowDataType, TableView } from 'owa-mail-list-store';
import { getItem } from 'owa-mail-list-store/lib/selectors/mailRowDataPropertyGetter';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default function preserveExistingDraftInstanceKey(
    row: MailListRowDataType,
    tableView: TableView
): MailListRowDataType {
    if (
        !isGlobalFeatureEnabled('cmp-offline-dedup-drafts') ||
        folderIdToName(tableView.tableQuery.folderId) !== 'drafts' ||
        row.__typename !== 'ItemRow' ||
        !row.IsDraft
    ) {
        return row;
    }

    const existingInstanceKey = tableView.rowKeys.find(instanceKey => {
        const existingItem = getItem(instanceKey, tableView);
        return existingItem?.ItemId?.Id === row.ItemId.Id;
    });

    return existingInstanceKey && existingInstanceKey !== row.InstanceKey
        ? { ...row, InstanceKey: existingInstanceKey }
        : row;
}
